import HeroSection from './components/HeroSection';
import ProblemaSection from './components/ProblemaSection';
import SolucionSection from './components/SolucionSection';
import BeneficiosSection from './components/BeneficiosSection';
import ComoFuncionaSection from './components/ComoFuncionaSection';
import PrecioSection from './components/PrecioSection';

const LOGO_URL = 'https://static.readdy.ai/image/dfc6db26b98ba2c0b04cea29bf715fac/72800120cdbe3fd9576126c278bba12a.png';

export default function HomePage() {
  return (
    <main className="min-h-screen" style={{ fontFamily: 'Inter, sans-serif' }}>
      <HeroSection />
      <ProblemaSection />
      <SolucionSection />
      <BeneficiosSection />
      <ComoFuncionaSection />
      <PrecioSection />

      {/* Footer */}
      <footer className="bg-stone-950 border-t border-stone-800 py-10 px-6 md:px-12">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex flex-col items-center sm:items-start gap-2">
            <img src={LOGO_URL} alt="ElaBooks Logo" className="h-8 object-contain" />
            <p className="text-stone-500 text-xs">
              Programa Digital de Educación Financiera Familiar
            </p>
          </div>
          <div className="flex flex-col items-center sm:items-end gap-1">
            <p className="text-stone-500 text-xs">
              © {new Date().getFullYear()} ElaBooks. Todos los derechos reservados.
            </p>
            <p className="text-stone-600 text-xs">
              Acceso inmediato · Descarga digital · Sistema completo
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
}
